<div class="help-info">
  <div class="help-info__heading heading heading_2">
    {{ 'help.f1' | translate }}
  </div>
  <div class="help-info__content" #content></div>
</div>
